export default "__VITE_ASSET__3a068400__"